export enum PopupTrigger
{
    Click = "onClick",
    DoubleClick = "onDoubleClick",
    RightClick = "onContextMenu",
    Hover = "onMouseEnter"
}